import React from 'react';
import ReactDOM from 'react-dom';
import { initializeApp } from 'firebase/app';
import { getMessaging, onMessage, getToken } from 'firebase/messaging';

import App from './App';
import { NotificationProvider } from './_helpers/NotificationContext';
import MyIsnpire from './static/img/auth/MyInspire.png';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/firebase-messaging-sw.js').catch(error => {
    console.error('ServiceWorker registration failed:', error);
  });
}
const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

getToken(messaging)
  .then(token => {
    localStorage.setItem('fcmToken', token);
    // Send the token to your server for further use
  })
  .catch(error => {
    console.error('Error obtaining FCM token:', error);
  });

onMessage(messaging, payload => {
  // Display a notification popup
  if (Notification.permission === 'granted') {
    const { data } = payload;
    new Notification('Message received', {
      body: data.message || 'Default message body',
      icon: MyIsnpire,
    });
  }

  // Handle the received message
  // Add your custom logic here
});

ReactDOM.render(
  <React.StrictMode>
    <NotificationProvider>
      <App />
    </NotificationProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);
